import { render, staticRenderFns } from "./PublishSharedLink.vue?vue&type=template&id=00e12e84&scoped=true&"
import script from "./PublishSharedLink.vue?vue&type=script&lang=ts&"
export * from "./PublishSharedLink.vue?vue&type=script&lang=ts&"
import style0 from "./PublishSharedLink.vue?vue&type=style&index=0&id=00e12e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e12e84",
  null
  
)

export default component.exports